// Affiliate links provided by Escapafy
export const AFFILIATES = {
  eci: "https://clk.tradedoubler.com/click?p=260156&a=3480623",
  clickrent: "https://visit.clickrent.es/click?p=374821&a=3480623",
  disneyland: "https://clk.tradedoubler.com/click?p=53148&a=3480623",
  barcelo: "https://clk.tradedoubler.com/click?p=269827&a=3480623",
  radisson: "https://clk.tradedoubler.com/click?p=344536&a=3480623",
  getYourGuide: "https://www.getyourguide.es?partner_id=TKM0GU7&cmp=share_to_earn",
  civitatis: "https://www.civitatis.com/es/?aid=112923",
};

// Tradedoubler tracking banners (used inside <a><img/></a> exactly as provided)
export const TRADEDOUBLER_BANNERS = {
  barceloCaribe: {
    href: "https://clk.tradedoubler.com/click?p=269827&a=3480623&g=25584018",
    img: "https://imp.tradedoubler.com/imp?type(img)g(25584018)a(3480623)",
    width: 500,
    height: 500,
  },
  radisson: {
    href: "https://clk.tradedoubler.com/click?p=344536&a=3480623&g=26001920",
    img: "https://imp.tradedoubler.com/imp?type(img)g(26001920)a(3480623)",
    width: 300,
    height: 600,
  },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/1o7vipvc_LogoEs.png";

export const PARTNERS = [
  { name: "Viajes El Corte Inglés", href: AFFILIATES.eci },
  { name: "Hoteles Barceló", href: AFFILIATES.barcelo },
  { name: "Clickrent", href: AFFILIATES.clickrent },
  { name: "Hoteles Radisson", href: AFFILIATES.radisson },
  { name: "Disneyland Paris", href: AFFILIATES.disneyland },
  { name: "GetYourGuide", href: AFFILIATES.getYourGuide },
  { name: "Civitatis", href: AFFILIATES.civitatis },
];

// Civitatis follows pattern: civitatis.com/es/{slug}/?aid=112923&cmp={City}
const civitatis = (slug, cmp) =>
  `https://www.civitatis.com/es/${slug}/?aid=112923&cmp=${cmp}`;

// Brand-styled placeholder: solid navy block. The card overlays the city name
// in Playfair white on top, so the result is an elegant editorial card.
const styledPlaceholder = () =>
  `https://placehold.co/1200x800/16335A/16335A/png`;

export const CITIES = [
  {
    id: "paris",
    name: "París",
    country: "Francia",
    tagline: "La eterna ciudad de la luz",
    description:
      "Cafés en Montmartre, atardeceres en el Sena y la Torre Eiffel iluminando la noche.",
    image:
      "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1200&q=80",
    categories: ["weekend", "bridge"],
    href: civitatis("paris", "Paris"),
    provider: "Civitatis",
  },  {
    id: "roma",
    name: "Roma",
    country: "Italia",
    tagline: "Tres mil años en cada esquina",
    description:
      "Coliseo, Vaticano y trattorias escondidas en Trastevere. Italia en su esencia.",
    image:
      "https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=1200&q=80",
    categories: ["weekend", "bridge"],
    href: civitatis("roma", "Roma"),
    provider: "Civitatis",
  },
  {
    id: "venecia",
    name: "Venecia",
    country: "Italia",
    tagline: "Una postal flotando sobre el agua",
    description:
      "Góndolas, máscaras y el Gran Canal al amanecer. Romántica como ninguna.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/clw81m5m_ven.png",
    imageScale: 1.18,
    categories: ["weekend"],
    href: civitatis("venecia", "Venecia"),
    provider: "Civitatis",
  },
  {
    id: "milan",
    name: "Milán",
    country: "Italia",
    tagline: "Diseño, moda y el Duomo",
    description:
      "Una escapada chic entre vermut y catedrales góticas. La capital del estilo.",
    image:
      "https://images.unsplash.com/photo-1520440229-6469a149ac59?auto=format&fit=crop&w=1200&q=80",
    categories: ["weekend"],
    href: civitatis("milan", "Milan"),
    provider: "Civitatis",
  },
  {
    id: "bruselas",
    name: "Bruselas",
    country: "Bélgica",
    tagline: "Cervezas, chocolate y Grand Place",
    description:
      "Una capital pequeña, sabrosa y cosmopolita. Perfecta para tres días intensos.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/8kh21a0i_brus.jpg",
    categories: ["weekend"],
    href: civitatis("bruselas", "Bruselas"),
    provider: "Civitatis",
  },
  {
    id: "burdeos",
    name: "Burdeos",
    country: "Francia",
    tagline: "Vinos, ribera y elegancia francesa",
    description:
      "La capital del vino te recibe con bulevares amplios y bodegas centenarias.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/4hiluplv_burds.webp",
    categories: ["day", "weekend"],
    href: civitatis("burdeos", "Burdeos"),
    provider: "Civitatis",
  },
  {
    id: "lisboa",
    name: "Lisboa",
    country: "Portugal",
    tagline: "Azulejos, fado y luz atlántica",
    description:
      "Tranvías amarillos por Alfama, miradores al Tajo y pastéis recién horneados.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/c4o1qxoh_lisb.jpg",
    categories: ["weekend", "bridge"],
    href: civitatis("lisboa", "Lisboa"),
    provider: "Civitatis",
  },
  {
    id: "oporto",
    name: "Oporto",
    country: "Portugal",
    tagline: "El alma del Duero",
    description:
      "Bodegas a orillas del Duero, librerías mágicas y el vino que da nombre a la ciudad.",
    image:
      "https://images.unsplash.com/photo-1555881400-74d7acaacd8b?auto=format&fit=crop&w=1200&q=80",
    categories: ["weekend", "bridge"],
    href: civitatis("oporto", "Oporto"),
    provider: "Civitatis",
  },
  {
    id: "niza",
    name: "Niza",
    country: "Francia",
    tagline: "Belle Époque y noches doradas",
    description:
      "Promenade des Anglais, mercados de Provenza y el sol de la Costa Azul.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/zp4paj37_ni.png",
    categories: ["weekend"],
    href: civitatis("niza", "Niza"),
    provider: "Civitatis",
  },
  {
    id: "montecarlo",
    name: "Montecarlo",
    country: "Mónaco",
    tagline: "Glamour entre yates y Belle Époque",
    description:
      "Casino, F1 y el pequeño Principado más exclusivo de Europa en un solo día.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/qlj182z8_mont.jpg",
    categories: ["day", "weekend"],
    href: civitatis("monaco", "Monaco"),
    provider: "Civitatis",
  },
  {
    id: "londres",
    name: "Londres",
    country: "Reino Unido",
    tagline: "Tradición, museos y barrios con alma",
    description:
      "Del Soho a Notting Hill: pubs, mercados de domingo y los mejores museos gratuitos de Europa.",
    image:
      "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg?auto=compress&cs=tinysrgb&w=1200",
    categories: ["weekend", "bridge"],
    href: civitatis("londres", "Londres"),
    provider: "Civitatis",
  },
  {
    id: "florencia",
    name: "Florencia",
    country: "Italia",
    tagline: "La cuna del Renacimiento",
    description:
      "Cúpula de Brunelleschi, Uffizi y Ponte Vecchio al atardecer. Italia hecha museo a cielo abierto.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/iv32f8bq_flo.jpg",
    categories: ["weekend"],
    href: civitatis("florencia", "Florencia"),
    provider: "Civitatis",
  },
  {
    id: "genova",
    name: "Génova",
    country: "Italia",
    tagline: "Mar, focaccia y callejones medievales",
    description:
      "Una joya ligur poco turística: caruggi estrechos, palacios UNESCO y el mejor pesto del mundo.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/69tep4gz_genova.jpg",
    categories: ["weekend"],
    href: civitatis("genova", "Genova"),
    provider: "Civitatis",
  },
  {
    id: "napoles",
    name: "Nápoles",
    country: "Italia",
    tagline: "Pizza, Vesubio y barrios que vibran",
    description:
      "La ciudad más viva de Italia. Y la puerta de entrada a Pompeya y la Costa Amalfitana.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/onu5xht9_nap.png",
    imageScale: 1.28,
    categories: ["weekend", "bridge"],
    href: civitatis("napoles", "Napoles"),
    provider: "Civitatis",
  },
  {
    id: "amsterdam",
    name: "Ámsterdam",
    country: "Países Bajos",
    tagline: "Canales, bicis y arte holandés",
    description:
      "Recorre los canales en barca, visita el Rijksmuseum y piérdete por el Jordaan. Pura vida slow.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/kz9fjdsn_ams.png",
    imageScale: 1.15,
    categories: ["weekend", "bridge"],
    href: civitatis("amsterdam", "Amsterdam"),
    provider: "Civitatis",
  },
  {
    id: "berlin",
    name: "Berlín",
    country: "Alemania",
    tagline: "Historia, contracultura y vida nocturna",
    description:
      "Muro de Berlín, Museumsinsel y los barrios más creativos de Europa: Kreuzberg y Friedrichshain.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/z7j1ywe9_ber.jpg",
    categories: ["weekend", "bridge"],
    href: civitatis("berlin", "Berlin"),
    provider: "Civitatis",
  },
  {
    id: "frankfurt",
    name: "Frankfurt",
    country: "Alemania",
    tagline: "Skyline alemán y mercados navideños",
    description:
      "La ciudad más cosmopolita de Alemania. Perfecta para una escapada urbana de fin de semana.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/6l29aha8_fk.jpg",
    categories: ["weekend"],
    href: civitatis("frankfurt", "Frankfurt"),
    provider: "Civitatis",
  },
  {
    id: "dublin",
    name: "Dublín",
    country: "Irlanda",
    tagline: "Pubs centenarios y literatura viva",
    description:
      "Pintas de Guinness en Temple Bar, Trinity College y la costa salvaje a un paso del centro.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/ms9g5rrt_dub.jpg",
    categories: ["weekend", "bridge"],
    href: civitatis("dublin", "Dublin"),
    provider: "Civitatis",
  },
  {
    id: "marrakech",
    name: "Marrakech",
    country: "Marruecos",
    tagline: "Zoco, riads y el desierto a un vuelo",
    description:
      "Aroma a especias en la medina, jardines Majorelle y atardeceres en Jemaa el-Fna. Exótica y cercana.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/hwimg7wc_marra.jpg",
    categories: ["bridge", "weekend"],
    href: civitatis("marrakech", "Marrakech"),
    provider: "Civitatis",
  },
  {
    id: "estrasburgo",
    name: "Estrasburgo",
    country: "Francia",
    tagline: "Lo mejor de Alsacia en un día",
    description:
      "Casco medieval, canales y la ruta de los pueblos de Alsacia. Excursión de un día desde Estrasburgo.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/dyca0f6r_est.png",
    imageScale: 1.22,
    categories: ["day", "weekend"],
    href: "https://www.getyourguide.com/es-es/estrasburgo-l293/desde-estrasburgo-lo-mejor-de-alsacia-en-una-excursion-de-un-dia-t272217/?ranking_uuid=8eafe5d4-1697-4d03-b869-7d19aff4f2dc&partner_id=TKM0GU7&cmp=CL",
    provider: "GetYourGuide",
  },
  {
    id: "baleares",
    name: "Baleares",
    country: "España",
    tagline: "Calas turquesas y mar Balear",
    description:
      "Mallorca, Menorca, Ibiza y Formentera. Calas vírgenes, gastronomía mediterránea y vuelos cortos desde la península.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/n0ewf2x1_bal.jpeg",
    categories: ["weekend", "bridge"],
    href: civitatis("baleares", "Baleares"),
    provider: "Civitatis",
  },
  {
    id: "andorra",
    name: "Andorra",
    country: "Pirineos",
    tagline: "Nieve, montaña y caminos blancos",
    description:
      "Estaciones de esquí, valles nevados y pueblos de piedra en pleno Pirineo. Una escapada perfecta de fin de semana.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/mffb9kzq_and.jpg",
    categories: ["weekend", "day"],
    href: civitatis("andorra", "Andorra"),
    provider: "Civitatis",
  },
  {
    id: "praga",
    name: "Praga",
    country: "República Checa",
    tagline: "Puente de Carlos y cielos de fuego",
    description:
      "Casco medieval, castillo gótico y el Vltava cruzando la ciudad. Una de las capitales más fotogénicas de Europa.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/mekpe313_pra.jpg",
    categories: ["weekend", "bridge"],
    href: "https://www.civitatis.com/es/republica-checa/?aid=112923&cmp=Praga",
    provider: "Civitatis",
  },
  {
    id: "cerdena",
    name: "Cerdeña",
    country: "Italia",
    tagline: "Aguas turquesas y rocas de granito",
    description:
      "Calas escondidas, mar transparente y la Costa Esmeralda. La isla mediterránea más salvaje y exclusiva.",
    image:
      "https://customer-assets.emergentagent.com/job_escapafy-travel/artifacts/2c1ni2l3_cerd.jpg",
    categories: ["weekend", "bridge"],
    href: "https://www.civitatis.com/es/cerdena/?aid=112923&cmp=Cerdena",
    provider: "Civitatis",
  },
];

export const CATEGORY_LABELS = {
  all: "Todas",
  weekend: "Fin de semana",
  day: "Un día",
  bridge: "Mini Viajes",
};
